module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/consultant/consultant-list/consultant-list.component.css
// module id = ./src/app/planning/consultant/consultant-list/consultant-list.component.css
// module chunks = main